import theme from "../style/theme";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";

import esp from '../assets/icons/flags/ESP.svg';
import cat from '../assets/icons/flags/AND.svg';

export default function Footer() {
    const { t, i18n } = useTranslation();

    return <div className="site-footer" style={{'--primary': theme.palette.primary.main, '--primary-dark': theme.palette.primary.dark, '--primary-light': theme.palette.primary.light, '--secondary': theme.palette.primary.dark, '--secondary-light': theme.palette.secondary.light}}>
        <div className="footer-container">
            <div className="footer-col footer-about">
                <div className="footer-logo">
                    <i className="fas fa-microchip"></i> {t('branding.name')}
                </div>
                <p className="footer-description">{t('branding.slogan')}</p>
                <div style={{display: 'flex', gap: '20px', flexWrap: 'wrap', margin: '10px 0'}}>
                    <Tooltip title={'ESPAÑOL'} sx={{zIndex: 10}}><div onClick={() => {i18n.changeLanguage('es'); document.documentElement.lang = 'es'}} className="flag"><img src={esp} alt="ESPAÑOL"/></div></Tooltip>
                    <Tooltip title={'CATALÀ'} sx={{zIndex: 10}}><div onClick={() => {i18n.changeLanguage('ca'); document.documentElement.lang = 'ca'}} className="flag"><img src={cat} alt="CATALÀ"/></div></Tooltip>
                </div>
            </div>

            <div className="footer-col">
                <h3 className="footer-title">{t('footer.quickLinks.title')}</h3>
                <ul className="footer-links">
                    <li><a href="/">{t('footer.quickLinks.links.home')}</a></li>
                    <li><a href='/users'>{t('navigation.users')}</a></li>
                    <li><a href='/balance'>{t('navigation.balance')}</a></li>
                    <li><a href='/mails'>{t('navigation.mails')}</a></li>
                    <li><a href='/solutions'>{t('navigation.solutions')}</a></li>
                    <li><a href='/web'>{t('navigation.web')}</a></li>
                    <li><a href='/dashboard'>{t('navigation.dashboard')}</a></li>
                </ul>
            </div>

            <div className="footer-col">
                <h3 className="footer-title">{t('footer.products.title')}</h3>
                <ul className="footer-links">
                    <li><a href="/solutions/mybillify">{t('footer.products.links.mybillify')}</a></li>
                </ul>
            </div>
        </div>

        <div className="footer-bottom">
            <div className="footer-container">
                <p>&copy; {t('cummon.copyright')}</p>
            </div>
        </div>
    </div>
}